export const currencyFormatter = new Intl.NumberFormat(undefined, {
    currency: 'USD',
    style: 'currency',
    minimumFractionDigits: 0,    
})